<template>
	<div class="hour-calendar">
		<span v-for="hour in hoursKeys" :class="`hour${hour}`" :key="hour"></span>
	</div>
</template>

<script>
const hoursKeys = [...new Array(24).keys()];
export default {
	data: () => ({
		hoursKeys,
	}),
};
</script>

<style lang="scss">
.hour-calendar {
	width: 120px;
	margin: 26px auto 4px auto;
	display: block;
	border-right: 1px solid var(--color-brown);
}
.hour-calendar .hour0::before {
	content: 'AM 12';
	position: absolute;
	bottom: 15px;
	font-size: 10px;
	line-height: 10px;
	left: -8px;
}
.hour-calendar .hour6::before {
	content: '6';
	position: absolute;
	bottom: 15px;
	font-size: 10px;
	line-height: 10px;
	left: -3px;
}
.hour-calendar .hour12::before {
	content: 'PM 12';
	position: absolute;
	bottom: 15px;
	font-size: 10px;
	line-height: 10px;
	left: -8px;
}
.hour-calendar .hour18::before {
	content: '6';
	position: absolute;
	bottom: 15px;
	font-size: 10px;
	line-height: 10px;
	left: -3px;
}
.hour-calendar * {
	width: 4px;
	height: 10px;
	border-left: 1px solid var(--color-brown);
	position: relative;
	display: inline-block;
}
.hour-calendar .hour0,
.hour-calendar .hour6,
.hour-calendar .hour12,
.hour-calendar .hour18 {
	height: 16px;
}
.hour-calendar .hour3,
.hour-calendar .hour9,
.hour-calendar .hour15,
.hour-calendar .hour21 {
	height: 13px;
}

.hour-calendar[data-hour0] .hour0 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour1] .hour1 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour2] .hour2 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour3] .hour3 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour4] .hour4 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour5] .hour5 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour6] .hour6 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour7] .hour7 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour8] .hour8 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour9] .hour9 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour10] .hour10 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour11] .hour11 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour12] .hour12 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour13] .hour13 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour14] .hour14 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour15] .hour15 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour16] .hour16 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour17] .hour17 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour18] .hour18 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour19] .hour19 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour20] .hour20 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour21] .hour21 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour22] .hour22 {
	background-color: var(--color-green);
}
.hour-calendar[data-hour23] .hour23 {
	background-color: var(--color-green);
}
</style>
